import React, { memo } from 'react'

const CustomScroll = ({
  children,
  className = '',
  //withoutPadding = true,
  isHorisontal,
}) => {
  //const containerRef = useRef()

  // const classNameIsScroll =
  //   !withoutPadding &&
  //   containerRef?.current?.offsetHeight < containerRef?.current?.scrollHeight
  //     ? 'scroll'
  //     : ''

  const classNameHorisontalScroll = isHorisontal ? 'with-horisontal' : ''

  return (
    <div
      className={`custom_scroll_container ${classNameHorisontalScroll} ${className}`}
      //ref={containerRef}
    >
      {children}
    </div>
  )
}

export default memo(CustomScroll)
